<div class="toolbar px-4 px-md-8">
    <div class="toolbar__left d-flex flex-row align-items-center flex-nowrap">
        @if (!hideBurgerMenu) {
            <div class="toolbar__burger pseudo pseudo--border-off me-6"
                 tabindex="0" (click)="burgerMenuClick.emit()"
                 (keydown.enter)="burgerMenuClick.emit()">
                <mat-icon>menu</mat-icon>
            </div>
        }

        @if (!hideLogo) {
            <div class="toolbar__logo">
                <app-logo />
            </div>
        }
    </div>

    <ng-content></ng-content>

    <div class="toolbar__lang">
        @if (languages?.length > 1) {
            <div class="lang-switcher">
                <div class="lang-switcher__icon">
                    <mat-icon fontIcon="language" />
                </div>
                <mat-select #select
                            class="lang-switcher__select"
                            [formControl]="selectControl"
                            panelClass="lang-switcher__panel"
                            disableRipple="">
                    @for (lang of languages; track lang.code) {
                        <mat-option [value]="lang">
                            <span class="lang-switcher__option">{{ lang.name }}</span>
                        </mat-option>
                    }
                </mat-select>
            </div>
        }

        @if (languages?.length === 1) {
            <div class="lang-switcher">
                {{ languages[0]?.name }}
            </div>
        }
    </div>
</div>
